/**
 * Javascript specific to the PCS Edge
 */

(function (window, document, $) {
	'use strict';

	// Call the function to parse URL query parameters on page load
	parseUrlQueryParams();

	// Set global variables
	const regDrawer = $('.register-drawer');
	const currentPageUrl = window.location.href;

	// Open drawer when PCS Link is clicked
	$('.pcs-drawer').click(function (e) {
		e.preventDefault();
		$('.content-drawer').addClass('drawer_open');
		$('.pcs-drawer-modal').removeClass('modal_hide')
		$('body').css('overflow', 'hidden');
	});

	// "Close" Drawer when Cancel btn is clicked    
	$('.content-drawer .cancel').click(function (e) {
		e.preventDefault();
		drawerClose();
	});

	// Close Drawer when Close btn is clicked
	$('.content-drawer .close-btn').click(function (e) {
		e.preventDefault();
		drawerClose();
	});
	// Close Drawer when Close btn is clicked
	$('.response-cancel').click(function (e) {
		e.preventDefault();
		drawerClose();
	});

	/* ========================================
	 * Drawer Close Functions
	 * ========================================
	 */
	function drawerClose() {
		$('.content-drawer').removeClass('drawer_open');
		$('.pcs-drawer-modal').addClass('modal_hide');
		regDrawer.delay(1000).addClass('show');
		$('#pcs-response').empty();
		$('body').css('overflow', 'auto');
	}


	/* ========================================
	 * Form Submit Functions
	 * ========================================
	 */
	// On Registration submit
	$('#edge_registration_submit').click(function (e) {
		e.preventDefault();
		pcsFormSubmit();
	});

	function pcsFormSubmit() {
		// Set vars
		let isValid = true;
		const edgeEmail = $('#edge_reg_form .form__field--email').val();
		const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
		$('.form__label').removeClass('invalid');
		$('.form__field').removeClass('invalid');

		// Function to check if the field is empty and add classes
		function validateField(selector) {
			if ($('.form__field--' + selector).val() === '') {
				$('.form__label--' + selector).addClass('invalid');
				$('.form__field--' + selector).addClass('invalid');
				isValid = false;
			} else {
				$('.form__label--' + selector).removeClass('invalid');
				$('.form__field--' + selector).removeClass('invalid');
			}
		}

		// Validate each required field
		// Field names
		let fields = ['firstname', 'lastname', 'regemail', 'job', 'company']

		// Loop through fields to validate them
		$.each(fields, function (index, field) {
			validateField(field);
		});

		if (regex.test(edgeEmail)) {
			// Remove class form email if it has it
			$('.form__label--email').removeClass('invalid');
			$('.form__field--email').removeClass('invalid');
			$('.form_email_req').hide();

			// Complete form submit
			if (isValid) {
				// Assign the form fields to the formFields object
				let formFields = {
					firstName: $('#firstname').val(),
					lastName: $('#lastname').val(),
					email: edgeEmail,
					jobTitle: $('#job').val(),
					companyName: $('#company').val(),
					emailVerificationUrl: currentPageUrl
				};

				// AJAX call the function that will run the API call
				$.ajax({
					type: "POST",
					url: localized.ajax_url,
					cache: false,
					data: {
						action: "pcs_reg_form",
						formFields: formFields,
					},
					beforeSend: function () {
						// Add spinner to reg button
						$(".submit").addClass('loading');
					},
					success: function (response) {
						$("#pcs-response").html(response);
						$(".submit").removeClass('loading');
						regDrawer.delay(1000).removeClass('show');
					},
					error: function (e) {
						console.log('error');
						console.log(e);
					}
				});
			}
		} else {
			// The email address is not valid
			$('.form__label--email').addClass('invalid');
			$('.form__field--email').addClass('invalid');
			$('.form_email_req').css('display', 'block');
			isValid = false;
		}
	}

	/* ========================================
	 * Function to Parse URL Query Parameters
	 * ========================================
	 */
	function parseUrlQueryParams() {
		const queryParams = new URLSearchParams(window.location.search);

		// Extracting 'email', 'code', 'consent', and/or "error" parameters
		const email = queryParams.get('email');
		const code = queryParams.get('code');
		const consent = queryParams.get('contact');
		const unauthorized = queryParams.get('error');

		// Use email and code to call verify API through AJAX
		if (email && code) {
			$('.content-drawer').addClass('drawer_open');
			$('.pcs-drawer-modal').removeClass('modal_hide')
			$('body').css('overflow', 'hidden');
			$('.loading-overlay').css('display', 'flex');

			// Assign the form fields to the formFields object
			let verifyQuery = {
				email: email,
				verificationCode: code,
			};

			// AJAX call the function that will run the API call
			$.ajax({
				type: "POST",
				url: localized.ajax_url,
				cache: false,
				data: {
					action: "pcs_verify_email",
					verifyQuery: verifyQuery,
				},
				success: function (response) {
					$("#pcs-response").html(response);
					$('.loading-overlay').hide();
					regDrawer.delay(1000).removeClass('show');
				},
				error: function (e) {
					console.log('error');
					console.log(e);
				}
			});
		}
		// Use consent to call verify API through AJAX
		else if (consent) {
			// Add spinner
			$('body').css('overflow', 'hidden');
			$('.pcs-fund-template .loading-overlay').css('display', 'flex');

			// Call function to run Consent AJAX
			edgeConsent();
		} else if (unauthorized) {
			// Open Drawer
			$('.content-drawer').addClass('drawer_open');
			$('.pcs-drawer-modal').removeClass('modal_hide')
			$('body').css('overflow', 'hidden');

			// Hide Register form and show Error message
			$('.register-drawer').hide();
			$('#unauthorized').show();
		}
	}

	/* ========================================
	 * Accordion
	 * ========================================
	 */
	$('.edge-fund__accordion-header').click(function () {
		let accordionTitle = $('.edge-fund__accordion-title');

		$('.edge-fund__accordion-content').slideToggle("fast");
		if (accordionTitle.hasClass("open")) {
			accordionTitle.removeClass("open");
		} else {
			accordionTitle.addClass("open");
		}
	});

	/* ========================================
	 * Currency
	 * ========================================
	 */
	$('.currency_selector').click(function () {
		$('.options-list').toggle(); // Show/hide the options list
		$('.currency_selector').toggleClass('open');
	});

	$('.options-list li').click(function (event) {
		event.stopPropagation();

		let selectedValue = $(this).text();
		let selectedDataValue = $(this).attr('data-value'); // Get the data-value attribute of the clicked li
		$('.selected-value').text(selectedValue).attr('data-value', selectedDataValue); // Store it in the selected-value div
		$('.options-list').hide();
		$('.currency_selector').removeClass('open');
	});

	/* ========================================
	 * Table Row Functions
	 * ========================================
	 */

	// Set Vars
	const allocationTag = $('.edge-fund__table-head-item .edge-fund__allocation');
	const allocationTagBottom = $('.edge-fund__allocation-summary-desktop .edge-fund__allocation');
	const allocationTagBottomMobile = $('.edge-fund__allocation-summary .edge-fund__allocation');

	// Close Message when x is clicked
	$('.edge-fund__message .jh-icon-No').click(function () {
		$('.edge-fund__message').hide();
	});

	// Add new Row
	$('#edge-fund__button-add').click(function (e) {
		e.preventDefault();
		addNewRow();
	});

	// Delete current row
	$(document).on('click', '.edge-fund__button-delete', function (e) {
		e.preventDefault();
		// Delete closest row
		$(this).closest('.edge-fund__table-row').remove();
		// Remove allocation message
		allocationTag.hide();
		allocationTagBottom.hide();
		allocationTagBottomMobile.hide();
		$('.edge-fund__message').hide();
	});

	// Reset Table
	$('.edge-fund__action-reset .edge-fund__link').click(function (e) {
		e.preventDefault();
		resetTable();
	});

	// Add new row function
	function addNewRow() {
		const rowCount = $('.edge-fund__table-row').length;
		if (rowCount < 60) {
			const clonedRow = $('.edge-fund__row-blank').first().clone();
			clonedRow.removeClass('edge-fund__row-blank').addClass('edge-fund__table-row');
			$('.edge-fund__table:not(.edge-fund__results-section) .edge-fund__table-body').append(clonedRow);
			return clonedRow; // Return the cloned row
		} else {
			$('#edge-fund__button-add').hide();
			return null; // Return null if no row was added
		}
	}

	// Reset Table function
	function resetTable() {
		const rows = $('.edge-fund__table:not(.edge-fund__results-section) .edge-fund__table-row');
		const rowsCount = rows.length;
		const desiredRowCount = 1;

		if (rowsCount > desiredRowCount) {
			// Remove extra rows
			rows.slice(desiredRowCount).remove();
		} else if (rowsCount < desiredRowCount) {
			// Add missing rows by cloning the blank row
			const rowToClone = $('.edge-fund__row-blank').first()
			for (let i = rowsCount; i < desiredRowCount; i++) {
				const clonedRow = rowToClone.clone();
				clonedRow.removeClass('edge-fund__row-blank').addClass('edge-fund__table-row');
				$('.edge-fund__table:not(.edge-fund__results-section) .edge-fund__table-body').append(clonedRow);
			}
		}

		// Clear values in each row
		$('.edge-fund__table-row').each(function () {
			$(this).find('input[type="text"], input[type="number"]').val(''); // Clear inputs
			$(this).find('.data').text('').attr('data-mstar', ''); // Clear data spans
			$(this).removeClass('error') // Remove error outline
		});

		// Show Reset input field
		$('.input-spinner').css('display', 'inline-block');

		// Remove Allocation message
		allocationTag.hide();
		allocationTagBottom.hide();
		allocationTagBottomMobile.hide();
		$('.edge-fund__message').hide();
	}

	/* ========================================
	 * Report Functions
	 * ========================================
	 */
	// Attach the combined handler to .allocation-value and fund name input fields
	$(document).on('input', '.allocation-value, .fund-name .data', updateValidation);

	// Validate to .00 decimals on Allocation input
	$('.allocation-value').on('input', function () {
		const value = $(this).val();

		if (value.includes('.') && value.split('.')[1].length > 2) {
			$(this).val(parseFloat(value).toFixed(2));
		}

		updateValidation(); // Trigger validation after formatting
	});

	// Run Report
	$('.edge-fund__action-report .edge-fund__link').click(function (e) {
		e.preventDefault();

		updateValidation(); // This handles validation and UI updates

		const { isInputValid, totalSum } = validateAndCalculate();
		const reportQuery = collectData();

		if (totalSum === 100 && isInputValid) {
			// Save reportQuery in a global variable or another accessible place
			window.reportQueryData = reportQuery;

			// Hide various sections on generated report
			$('.edge-fund__intro:not(.generated-report-head)').hide();
			$('.edge-fund__portfolio-actions:not(.edge-fund__report-actions)').hide();
			$('.edge-fund__actions-container').hide();

			// Show generated report sections
			$('.edge-fund__intro.generated-report-head').show();
			$('.edge-fund__report-actions').css('display', 'flex');

			// Add class for targeted style changes
			$('.edge-fund__table:not(.edge-fund__results-section)').hide();
			$(".edge-fund__body").addClass('generated-report');

			// Scroll to the report section
			$('html, body').animate({
				scrollTop: $(".edge-fund__header--bottom").offset().top
			}, 500);
		} else {
			$('.edge-fund__message span').text('Please add a fund and its allocation.');
		}
	});

	// Open Generated PDF
	$('.edge-fund__generated-report-link').click(function (e) {
		e.preventDefault();
		submitForm(window.reportQueryData);
	});

	// Run new report
	$('.edge-fund__action-new-report .edge-fund__link').click(function (e) {
		e.preventDefault();
		$(this).addClass('loading');
		location.reload();
	});

	// Function to collect report data
	function collectData() {
		let reportQuery = {
			"SalesforceId": "",
			"LanguageCountryCode": "",
			"CurrencyId": $('.selected-value').attr('data-value') || 'Local',
			"Timezone": "",
			"Funds": []
		};

		$('.edge-fund__table:not(.edge-fund__results-section) .edge-fund__table-row').each(function (index) {
			let mstarId = $(this).find('.edge-fund__table-cell.fund-name .data').attr('data-mstar');
			let weight = parseFloat($(this).find('.edge-fund__table-cell.allocation input').val()) || 0;

			if (mstarId && weight > 0) {
				reportQuery.Funds.push({
					MstarId: mstarId,
					RowIndex: index,
					Weight: weight
				});
			}
		});

		return reportQuery;
	}

	// Function to submit the form
	function submitForm(reportQuery) {
		let currentPath = window.location.pathname.replace(/\/$/, '');
		let pageUrl = currentPath + '/pcs-report/';

		let form = $('<form>', {
			'action': pageUrl,
			'method': 'POST',
			'target': '_blank'
		});

		form.append($('<input>', {
			'type': 'hidden',
			'name': 'reportQuery',
			'value': JSON.stringify(reportQuery)
		}));

		form.append($('<input>', {
			'type': 'hidden',
			'name': 'edgeGlobal',
			'value': $('#edge-global').attr('data-edge-global')
		}));

		$('body').append(form);
		form.submit();
	}

	/* ================================================
	 * Validate, Calculate, and Error/Styling Functions
	 * ================================================
	 */
	// Function to validate a single row
	function validateRow(row, duplicateISINs = []) {
		const $row = $(row);
		const inputValue = parseFloat($row.find('.allocation-value').val());
		const fundName = $row.find('.fund-name .data').text().trim();
		const isin = $row.find('.identifier .data').text().trim();
		const $allocationInput = $row.find('.allocation-value');
		const $fundNameInput = $row.find('.fund-name input');

		let isValid = true;

		// Reset error states
		$row.removeClass('error');
		$allocationInput.removeClass('error');
		$fundNameInput.removeClass('error');

		// Check if this ISIN is a duplicate
		if (isin && duplicateISINs.includes(isin)) {
			isValid = false;
			$row.addClass('error');
			// Add a title attribute to show on hover
			$row.find('.fund-name .data').attr('title', 'Duplicate ISIN: ' + isin);
		}

		// Validate fund name
		if (!validateFundName(fundName)) {
			isValid = false;
			$fundNameInput.addClass('error');
		}

		// Validate allocation value
		if (!validateAllocationValue(inputValue)) {
			isValid = false;
			$allocationInput.addClass('error');
		}

		// Check for mismatched inputs
		if (validateMismatchedInputs(inputValue, fundName)) {
			isValid = false;
			$row.addClass('error');
		}

		if (!isValid) {
			$row.addClass('error');
		}

		return { isValid, value: inputValue || 0 };
	}

	// Function to validate fund name
	function validateFundName(fundName) {
		return fundName.length > 0;
	}

	// Function to validate allocation value
	function validateAllocationValue(value) {
		return !isNaN(value) && value > 0;
	}

	// Function to check for mismatched inputs
	function validateMismatchedInputs(value, fundName) {
		return (value > 0 && fundName.length === 0) || (value <= 0 && fundName.length > 0) || (isNaN(value) && fundName.length > 0);
	}

	// Main validation function
	function validateAndCalculate() {
		let totalSum = 0;
		let isInputValid = true;

		// Find duplicate ISINs
		const allISINs = [];
		const duplicateISINs = [];

		// First pass: collect all ISINs
		$('.edge-fund__table:not(.edge-fund__results-section) .edge-fund__table-row').each(function () {
			const isin = $(this).find('.identifier .data').text().trim();
			if (isin) {
				if (allISINs.includes(isin) && !duplicateISINs.includes(isin)) {
					// Found a duplicate
					duplicateISINs.push(isin);
				}
				allISINs.push(isin);
			}
		});

		// Second pass: validate rows with duplicate information
		$('.edge-fund__table:not(.edge-fund__results-section) .edge-fund__table-row').each(function () {
			const { isValid, value } = validateRow(this, duplicateISINs);
			isInputValid = isInputValid && isValid;
			totalSum += value;
		});

		totalSum = parseFloat(totalSum.toFixed(2));
		const totalSumText = totalSum.toFixed(2) + '% / 100.00%';

		// If duplicates were found, show a specific message
		if (duplicateISINs.length > 0) {
			$('.edge-fund__message span').text('Duplicate ISINs found. Please remove duplicate funds before running report.');
		}

		// Update allocation tags and apply styles
		updateAllocationTags(totalSumText, totalSum === 100 && isInputValid);

		return { isInputValid, totalSum };
	}

	// Function to update allocation tags
	function updateAllocationTags(text, isSuccess) {
		const tags = [allocationTag, allocationTagBottom, allocationTagBottomMobile];
		const successClass = isSuccess ? 'success' : 'error';
		const errorClass = isSuccess ? 'error' : 'success';

		tags.forEach(tag => {
			tag.css('display', 'block').html(text).removeClass(errorClass).addClass(successClass);
		});

		$('.edge-fund__message').css('display', isSuccess ? 'none' : 'flex');

		updateDisplay();
	}

	// Function to Update allocation tags
	function updateDisplay() {
		const displayStyle = $(window).width() > 991 ? 'inline-block' : 'none';
		allocationTagBottom.css('display', displayStyle);
		allocationTagBottomMobile.css('display', displayStyle === 'inline-block' ? 'none' : 'inline-block');
	}

	// Function to call validate and styles function at various times
	function updateValidation() {
		const { isInputValid, totalSum } = validateAndCalculate();
		const totalSumText = totalSum.toFixed(2) + '% / 100.00%';
		const message = isInputValid && totalSum === 100 ? '100%' : totalSumText;

		updateAllocationTags(message, isInputValid && totalSum === 100);
	}

	/* ========================================
	 * Fund Entry Functions
	 * ========================================
	 */

	let typingTimer;               // Timer identifier
	let doneTypingInterval = 500;  // Time in ms (.5 second)
	let currentAjaxRequest = null; // Hold current AJAX Request

	// On focus add .active class, remove on blur
	$(document).on('focus', '.fund-name', function () {
		// Remove the 'active' class from all '.fund-name' elements
		$('.fund-name').parent().removeClass('active');

		// Add the 'active' class to the focused '.fund-name' element
		$(this).parent().addClass('active');
	}).on('blur', '.fund-name', function () {
		$('.fund-name .input-spinner').removeClass('loading');

		// Set a timeout before hiding the .edge-fund__results
		setTimeout(function () {
			$('.fund-name .edge-fund__results').hide();
		}, 300); // Delay in milliseconds, 1000ms = 1 second
	});

	// On keyup, start the countdown; On keydown, clear the countdown
	$(document).on('keyup', '.fund-name input', function () {
		clearTimeout(typingTimer);
		typingTimer = setTimeout(doneTyping, doneTypingInterval);
	}).on('keydown', '.fund-name input', function () {
		clearTimeout(typingTimer);
		$('.fund-name .input-spinner').removeClass('loading');
		$('.active .fund-name .edge-fund__results').hide();
	});

	// User is "finished typing," do something
	function doneTyping() {
		$('.active .fund-name .input-spinner').addClass('loading');
		const searchValue = $('.active .fund-name input').val();

		// If there is an ongoing AJAX call, abort it (this means the user is typing again after call is being made)
		if (currentAjaxRequest !== null) {
			currentAjaxRequest.abort();
		}

		// Assign the form fields to the formFields object
		let searchQuery = {
			searchText: searchValue,
			count: '100',
		};

		// AJAX call for Search API
		currentAjaxRequest = $.ajax({
			type: "GET",
			url: localized.ajax_url,
			cache: false,
			data: {
				action: "pcs_fund_search",
				searchQuery: searchQuery,
			},
			success: function (response) {
				$('.active .fund-name .edge-fund__results-output').html(response);
				$('.active .fund-name .input-spinner').removeClass('loading');
				$('.active .fund-name .edge-fund__results').css('display', 'block');

				$('.active .fund-name .edge-fund__results-output .edge-fund__results-item').click(function () {
					const $activeRow = $(this).closest('.edge-fund__table-row.active');

					// Remove any lingering error classes from the row
					$activeRow.removeClass('error');
					$activeRow.find('.fund-name .data, .allocation-value').removeClass('error');

					// This captures all data attributes from the clicked list item
					let allDataAttributes = $(this).data();

					// Hide Fund name input field, spinner, and results dropdown
					$activeRow.find('.fund-name .input-spinner').hide();

					// Change out Data for each column
					$activeRow.find('.fund-name .data').html(allDataAttributes.name).attr('data-mstar', allDataAttributes.mstar);
					$activeRow.find('.identifier .data').html(allDataAttributes.isin);
					$activeRow.find('.category .data').html(allDataAttributes.category);
					$activeRow.find('.currency .data').html(allDataAttributes.currency);

					// Validate the row after updating
					validateRow($activeRow[0]);

					// Recalculate and update validation for the entire table
					updateValidation();
				});
			},
			error: function (e) {
				console.log('error');
				console.log(e);
			}
		});
	}

	/* ========================================
	 * Contact Sales
	 * ========================================
	 */
	$('.edge-fund__action-contact .edge-fund__link').click(function (e) {
		e.preventDefault();

		// Add loading to button
		$('.edge-fund__action-contact .edge-fund__link').addClass('loading');

		// Call function to run Consent AJAX
		edgeConsent();
	});

	// Close modal
	$('#edge-fund__modal .close, #edge-fund__modal .close-modal').click(function (e) {
		e.preventDefault();
		$('#edge-fund__modal').hide();
		$('body').css('overflow', 'auto');
	});

	function edgeConsent() {
		// Grab EdgeGlobal data
		let edgeConsent = {
			contactId: $('#edge-global').attr('data-edge-global'),
			consent: true
		};

		// AJAX call to function for Contact API Call
		$.ajax({
			type: "POST",
			url: localized.ajax_url,
			cache: false,
			data: {
				action: "pcs_contact_sales",
				edgeConsent: edgeConsent,
			},
			success: function (response) {
				// On success remove loading button and spinners
				$('.edge-fund__action-contact .edge-fund__link').removeClass('loading');
				$('.pcs-fund-template .loading-overlay').hide();

				// Replace content in Modal
				$('#response-content').html(response);

				// Show Modal on page that give a confirmation that it sent through
				$('#edge-fund__modal').css('display', 'flex');
				$('body').css('overflow', 'hidden');
			},
			error: function (e) {
				console.log('error');
				console.log(e);
			}
		});
	}

	/* ========================================
	 * Log user out after 15mins
	 * ========================================
	 */
	// Check if the .pcs-fund-template class exists on the page
	if ($('.pcs-fund-template').length > 0) {
		// Listen for mouse clicks and keyboard events. If nothing for 15min then force page reload.
		let timeout = 0;

		function resetTimeout() {
			clearTimeout(timeout);

			timeout = setTimeout(function () {
				// Parse the current URL properly
				const currentUrl = new URL(window.location.href);

				// Get path segments and find language code segment
				const pathSegments = currentUrl.pathname.split('/').filter(segment => segment);
				let langCodeIndex = -1;

				// Find the language code segment (e.g., "en-gb")
				for (let i = 0; i < pathSegments.length; i++) {
					if (pathSegments[i].match(/^[a-z]{2}-[a-z]{2}$/i)) {
						langCodeIndex = i;
						break;
					}
				}

				// Construct the base path up to adviser (or equivalent)
				let basePath = '';
				if (langCodeIndex !== -1 && langCodeIndex + 1 < pathSegments.length) {
					// Include language code and the segment after it (typically "adviser")
					basePath = '/' + pathSegments.slice(0, langCodeIndex + 2).join('/');
				} else {
					// Fallback - just use the language code if found
					basePath = langCodeIndex !== -1 ? '/' + pathSegments.slice(0, langCodeIndex + 1).join('/') : '';
				}

				// Ensure trailing slash
				if (!basePath.endsWith('/')) {
					basePath += '/';
				}

				// Create the redirect URL with the proper structure
				const redirectUrl = currentUrl.origin + basePath + 'portfolio-construction-and-strategy/';

				// Redirect to the login page
				window.location.href = redirectUrl;
			}, 1200000); // 15 minutes in milliseconds (reset from test value)
		}

		// Reset the timeout on mouse click and keypress
		$(document).on('click keypress', function () {
			resetTimeout();
		});

		// Initialize the timeout for the first time
		resetTimeout();
	}

	/* ========================================
	 * Upload CSV Functions
	 * ========================================
	 */
	// Show modal when upload link is clicked
	$('.edge-fund__action--upload .edge-fund__link').click(function (e) {
		e.preventDefault();
		// Make sure Upload form shows
		$('#upload-csv').css('display', 'block');

		// Hide close button for design purposes
		$('.modal-footer').hide();

		// Show Modal on page that give a confirmation that it sent through
		$('#edge-fund__modal').css('display', 'flex');
		$('body').css('overflow', 'hidden');
	});

	// Submit the form when the submit button is clicked
	$('#csv-upload-form .submit a').click(function (e) {
		e.preventDefault();

		// Submit the form
		$('#csv-upload-form').submit();
	});

	$('#csv-upload-form').on('submit', function (e) {
		e.preventDefault();
		// Close modal and show modal footer again
		$('.modal-footer').show();
		$('#edge-fund__modal').hide();

		// Add Spinner to page
		$('.pcs-fund-template .loading-overlay').css('display', 'flex');

		let formData = new FormData(this);
		formData.append('action', 'pcs_csv_upload');

		$.ajax({
			type: "POST",
			url: localized.ajax_url,
			cache: false,
			data: formData,
			processData: false,  // Don't process the files
			contentType: false,  // Don't set contentType
			success: function (response) {
				// Remove spinner and allow scrolling
				$('.pcs-fund-template .loading-overlay').hide();
				$('body').css('overflow', 'auto');

				// Reset the table so that the new upload does not append
				resetTable();

				// If successful execute the following code
				if (response.success) {
					const fundData = response.data;
					// Track ISINs to detect duplicates
					const seenISINs = new Set();

					fundData.forEach((item, index) => {
						// set var for currentRow
						let currentRow;

						// Check if we are in the first table row, if not then add a new row
						if (index === 0) {
							currentRow = $('.edge-fund__table-row').first();
						} else {
							currentRow = addNewRow();
						}

						// Check if new row was added due to 60 row limit
						if (currentRow) {
							// Replace allocation input val with allocation from data
							currentRow.find('.allocation-value').val(item.allocation);

							// Check if there's an error flag or if it's a duplicate ISIN
							const isinValue = item.ISIN || (item.data && item.data[0] ? item.data[0].isin : null);
							const isDuplicate = isinValue && seenISINs.has(isinValue);

							if (item.error || isDuplicate) {
								// Replace ISIN input val with ISIN from data
								currentRow.find('.fund-name .input-spinner input').val(item.ISIN || '');
								currentRow.addClass('error');
								currentRow.find('.fund-name .data').addClass('error');

								// Show specific message for duplicate ISINs
								if (isDuplicate) {
									currentRow.find('.fund-name .data')
										.html(`Duplicate ISIN: ${isinValue}`)
										.attr('title', 'This ISIN has already been added');
								}

								$('.edge-fund__message span').text('Please correct the error(s) in the highlighted row(s) before running report.');
							} else {
								// Assuming 'data' is present and is an array
								if (item.data && item.data.length > 0) {
									// Add ISIN to seen set
									if (item.data[0].isin) {
										seenISINs.add(item.data[0].isin);
									}

									// Hide Fund name input field, spinner, and results dropdown
									currentRow.find('.fund-name .input-spinner').hide();

									// Change out Data for each column
									currentRow.find('.fund-name .data').html(item.data[0].name).attr('data-mstar', item.data[0].mstarId);
									currentRow.find('.identifier .data').html(item.data[0].isin);
									currentRow.find('.category .data').html(item.data[0].category);
									currentRow.find('.currency .data').html(item.data[0].currency);
								}

								// Update Allocation Tags
								const { isInputValid, totalSum } = validateAndCalculate();
								updateAllocationTags(totalSum.toFixed(2) + '% / 100.00%', isInputValid && totalSum === 100);
							}

							// Validate the current row
							validateRow(currentRow[0]);
						}
					});

					// Validate the Rows
					$('.edge-fund__table-row').each(function () {
						validateRow(this);
					});

					updateValidation();

					// Scroll to the Table
					$('html, body').animate({
						scrollTop: $(".edge-fund__body").offset().top
					}, 500);
				} else {
					// Hide close button for design purposes
					$('.modal-footer').hide();

					// Show Modal on page that give a confirmation that it sent through
					$('#edge-fund__modal').css('display', 'flex');
					$('body').css('overflow', 'hidden');

					// Add error message to modal
					$('#edge-fund__modal .error-message').css('display', 'block').html(response.data);
				}
			},
			error: function (e) {
				console.log('error');
				console.log(e);

				// Reset validation state
				$('.edge-fund__table-row').removeClass('error');
				$('.edge-fund__table-row').find('.fund-name .data, .allocation-value').removeClass('error');
				updateValidation();
			}
		});
	});


})(window, document, jQuery);
